<div class="grid lg:grid-cols-12 py-16 bg-gray-50 mb-10">
  <div class="col-span-12 lg:col-span-8 lg:col-start-3">

    <!-- Sign up form (initial step) -->
    <form class="mt-8 space-y-6" (submit)="onSubmit($event)" *ngIf="!showConfirm">
      <div class="bg-white p-8 rounded-t-lg shadow space-y-6">
        <div>
          <h1 class="justify-start text-gray-900 text-xl font-bold font-['Inter'] leading-tight">Seus dados</h1>
          <p class="text-sm text-gray-500">Já tem uma conta?
            <a routerLink="/login" class="text-blue-700 hover:underline">Entrar</a>
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Nome</label>
            <input name="name" type="text" required
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Sobrenome</label>
            <input name="family_name" type="text" required
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">E-mail</label>
            <input name="email" type="email" required placeholder="seu@email.com"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Confirmar e-mail</label>
            <input name="confirm_email" type="email" required placeholder="confirmar e-mail"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Telefone</label>
            <input name="phone_number" type="tel" placeholder=""
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div class="md:col-span-1">
            <label class="block text-sm font-medium text-gray-900 mb-2">Endereço</label>
            <input name="address" type="text"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">CEP</label>
            <input name="postalcode" type="text"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Estado</label>
            <input name="state" type="text"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Cidade</label>
            <input name="city" type="text"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Gênero</label>
            <select name="gender"
                    class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500">
              <option value="">Selecione</option>
              <option value="male">Masculino</option>
              <option value="female">Feminino</option>
              <option value="other">Outro</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-2">Data de nascimento</label>
            <input name="birthdate" type="date"
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
        </div>

        <div *ngIf="error" class="text-red-600 text-sm">{{ error }}</div>
        <div *ngIf="success" class="text-green-700 text-sm">{{ success }}</div>
      </div>

      <div class="bg-white p-8 rounded-t-lg shadow space-y-6">
        <div>
          <h1 class="justify-start text-gray-900 text-xl font-bold font-['Inter'] leading-tight">Senha</h1>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

          <div class="">
            <label class="block text-sm font-medium text-gray-900 mb-2">Senha</label>
            <input name="password" type="password" required
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />

            <label class="mt-4 block text-sm font-medium text-gray-900 mb-2">Confirmar senha</label>
            <input name="confirm_password" type="password" required
                   class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-500" />
          </div>
        </div>

        <div *ngIf="error" class="text-red-600 text-sm">{{ error }}</div>
        <div *ngIf="success" class="text-green-700 text-sm">{{ success }}</div>
      </div>

      <button type="submit"
              class="bg-blue-600 text-white px-5 py-2.5 rounded-md w-full disabled:opacity-50"
              [disabled]="isPending">
        {{ isPending ? 'Criando...' : 'Criar conta' }}
      </button>
    </form>

    <!-- Confirm sign-up form (after sign up) -->
    <div *ngIf="showConfirm" class="mt-8 space-y-6">
      <div class="bg-white p-8 rounded-t-lg shadow space-y-6">
        <div>
          <h2 class="text-2xl font-bold text-gray-900 leading-loose">Confirmar cadastro</h2>
          <p class="text-sm text-gray-500">Enviamos um código para {{ emailForConfirm }}. Digite-o abaixo para confirmar sua conta.</p>
        </div>

        <form (submit)="onConfirmSubmit($event)" class="space-y-4">
          <div>
            <label for="confirm-code" class="block text-sm font-medium text-gray-900">Código de confirmação</label>
            <input id="confirm-code" name="confirmation_code" type="text" required
                   class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2"
                   placeholder="Código" />
          </div>

          <div *ngIf="confirmError" class="text-red-600 text-sm">{{ confirmError }}</div>
          <div *ngIf="confirmSuccess" class="text-green-700 text-sm">{{ confirmSuccess }}</div>

          <div class="flex items-center justify-between">
            <div class="flex gap-3">
              <button type="button" class="text-sm text-blue-700 hover:underline" (click)="resendCode()" [disabled]="isResending">
                {{ isResending ? 'Reenviando...' : 'Reenviar código' }}
              </button>
              <button type="button" class="text-sm text-blue-700 hover:underline" (click)="backToEdit()">Alterar e-mail</button>
              <a routerLink="/login" class="text-sm text-blue-700 hover:underline">Ir para o login</a>
            </div>
            <button type="submit" class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50" [disabled]="isConfirming">
              {{ isConfirming ? 'Confirmando...' : 'Confirmar' }}
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>
